import React from 'react';
import { Question } from '../data/questions';
import { Card } from './ui/Card';
interface QuestionCardProps {
  question: Question;
  selectedValue?: number;
  onSelect: (value: number) => void;
}
export function QuestionCard({
  question,
  selectedValue,
  onSelect
}: QuestionCardProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-22">
      <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" data-id="element-23">
        {question.text}
      </h2>
      <p className="text-sm font-medium text-blue-600 mb-6 uppercase tracking-wide" data-id="element-24">
        Dimensão: {question.dimension}
      </p>

      <div className="space-y-3" data-id="element-25">
        {question.options.map(option => <Card key={option.value} onClick={() => onSelect(option.value)} className={`p-4 flex items-center group transition-all duration-200 ${selectedValue === option.value ? 'ring-2 ring-slate-900 bg-slate-50' : 'hover:bg-slate-50'}`} data-id="element-26">
            <div className={`
              w-6 h-6 rounded-full border-2 flex items-center justify-center mr-4 flex-shrink-0 transition-colors
              ${selectedValue === option.value ? 'border-slate-900 bg-slate-900' : 'border-slate-300 group-hover:border-slate-400'}
            `} data-id="element-27">
              {selectedValue === option.value && <div className="w-2.5 h-2.5 bg-white rounded-full" data-id="element-28" />}
            </div>
            <span className={`text-base ${selectedValue === option.value ? 'font-medium text-slate-900' : 'text-slate-700'}`} data-id="element-29">
              {option.label}
            </span>
          </Card>)}
      </div>
    </div>;
}